import React, { useCallback } from 'react';
import { useFormikContext } from 'formik';

import FormInput from '../form-input/FormInput';
import { PasswordError } from '../index';

type Props = React.ComponentProps<typeof FormInput>;

const FormPasswordInput = ({
  name,
  onInput,
  ...props
}: Props) => {
  const { touched, setTouched } = useFormikContext();
  const earlyTouch = useCallback((e: React.FormEvent<HTMLDivElement>) => {
    if (onInput) {
      onInput(e);
    }

    if (!e.defaultPrevented) {
      setTouched({
        ...touched,
        [name]: true,
      });
    }
  }, [setTouched, touched, name, onInput]);

  return (
    <>
      <FormInput
        name={name}
        type="password"
        hideErrors
        {...props}
        onInput={earlyTouch}
      />
      <PasswordError name={name} />
    </>
  );
};

export default FormPasswordInput;
